export default __webpack_public_path__ + "static/media/Kerstin_Hoepfner.237fb900.jpeg";